/**
 * External dependencies
 */
import classnames from "classnames";

const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;

class Buttons extends Component {
  constructor() {
    super(...arguments);
  }
  render() {
    const {
      attributes: { theme, order, counter, likeButtonSize, showTotalCount }
    } = this.props;

    var output = Array();
    var showCounter = counter;
    var buttonStyle = {};
    //fblike, totalshare -> having issue
    var knownNetworks = Array(
      "twitter",
      "pinterest",
      "fbshare",
      "linkedin",
      "reddit",
      "whatsapp",
      "viber",
      "messenger",
      "email",
      "fblike",
      "print",
      "tumblr"
    );

    
    let selectedNetworks = order.split(",");
    if ( counter && showTotalCount) {
      selectedNetworks.push("totalshare");
    }
    selectedNetworks.forEach((network, index) => {

      switch (network) {
        case "fbshare":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_fbshare-icon" target="_blank">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    class="_1pbq"
                    color="#ffffff"
                  >
                    <path
                      fill="#ffffff"
                      fill-rule="evenodd"
                      class="icon"
                      d="M8 14H3.667C2.733 13.9 2 13.167 2 12.233V3.667A1.65 1.65 0 0 1 3.667 2h8.666A1.65 1.65 0 0 1 14 3.667v8.566c0 .934-.733 1.667-1.667 1.767H10v-3.967h1.3l.7-2.066h-2V6.933c0-.466.167-.9.867-.9H12v-1.8c.033 0-.933-.266-1.533-.266-1.267 0-2.434.7-2.467 2.133v1.867H6v2.066h2V14z"
                    ></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">Share </span>
                {showCounter && <span class="ssb_counter"> 5 </span>}
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-fb-share" style={buttonStyle}>
                <span class="simplesocialtxt">Facebook </span>
                {showCounter && (
                  <span class="ssb_counter ssb_fbshare_counter">5</span>
                )}
              </button>
            );
          }
          break;
        case "twitter":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_tweet-icon" rel="nofollow">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                    <path fill="none" d="M0 0h72v72H0z" />
                    <path
                      class="icon"
                      fill="#fff"
                      d="M68.812 15.14c-2.348 1.04-4.87 1.744-7.52 2.06 2.704-1.62 4.78-4.186 5.757-7.243-2.53 1.5-5.33 2.592-8.314 3.176C56.35 10.59 52.948 9 49.182 9c-7.23 0-13.092 5.86-13.092 13.093 0 1.026.118 2.02.338 2.98C25.543 24.527 15.9 19.318 9.44 11.396c-1.125 1.936-1.77 4.184-1.77 6.58 0 4.543 2.312 8.552 5.824 10.9-2.146-.07-4.165-.658-5.93-1.64-.002.056-.002.11-.002.163 0 6.345 4.513 11.638 10.504 12.84-1.1.298-2.256.457-3.45.457-.845 0-1.666-.078-2.464-.23 1.667 5.2 6.5 8.985 12.23 9.09-4.482 3.51-10.13 5.605-16.26 5.605-1.055 0-2.096-.06-3.122-.184 5.794 3.717 12.676 5.882 20.067 5.882 24.083 0 37.25-19.95 37.25-37.25 0-.565-.013-1.133-.038-1.693 2.558-1.847 4.778-4.15 6.532-6.774z"
                    />
                  </svg>
                </span>
                {showCounter ? (
                  <i class="simplesocialtxt">Tweet 5 </i>
                ) : (
                  <i class="simplesocialtxt">Tweet </i>
                )}
              </button>
            );
          } else {
            output.push(
              <button
                class="simplesocial-twt-share"
                rel="nofollow"
                style={buttonStyle}
              >
                <span class="simplesocialtxt">Twitter</span>
                {showCounter && (
                  <span class="ssb_counter ssb_twitter_counter"> 5 </span>
                )}
              </button>
            );
          }
          break;

        case "linkedin":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_linkedin-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="14.1"
                    x="0"
                    y="0"
                    version="1.1"
                    viewBox="-301.4 387.5 15 14.1"
                    xmlSpace="preserve"
                  >
                    <g fill="#FFF">
                      <path d="M-296.2 401.6v-9.5h3c.1 0 .1 0 .1.1v1.2c.1-.1.2-.3.3-.4.5-.7 1.2-1 2.1-1.1.8-.1 1.5 0 2.2.3.7.4 1.2.8 1.5 1.4.4.8.6 1.7.6 2.5v5.5h-3.2v-.2-4.8c0-.4 0-.8-.2-1.2-.2-.7-.8-1-1.6-1-.8.1-1.3.5-1.6 1.2-.1.2-.1.5-.1.8v5.1c0 .2 0 .2-.2.2h-2.9c.1-.1 0-.1 0-.1zM-298 401.6h-3c-.1 0-.1 0-.1-.1v-9.2c0-.1 0-.1.1-.1h3v9.4zM-299.6 390.9c-.7-.1-1.2-.3-1.6-.8-.5-.8-.2-2.1 1-2.4.6-.2 1.2-.1 1.8.2.5.4.7.9.6 1.5-.1.7-.5 1.1-1.1 1.3-.2.1-.5.1-.7.2z"></path>
                    </g>
                  </svg>
                </span>
                <span class="simplesocialtxt">Share</span>
              </button>
            );
          } else {
            output.push(
              <button target="popup" class="simplesocial-linkedin-share">
                <span class="simplesocialtxt">LinkedIn</span>
              </button>
            );
          }
          break;
        case "pinterest":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_pinterest-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="30px"
                    width="30px"
                    viewBox="-1 -1 31 31"
                  >
                    <g>
                      <path
                        d="M29.449,14.662 C29.449,22.722 22.868,29.256 14.75,29.256 C6.632,29.256 0.051,22.722 0.051,14.662 C0.051,6.601 6.632,0.067 14.75,0.067 C22.868,0.067 29.449,6.601 29.449,14.662"
                        fill="#fff"
                        stroke="#fff"
                        stroke-width="1"
                      ></path>
                      <path
                        d="M14.733,1.686 C7.516,1.686 1.665,7.495 1.665,14.662 C1.665,20.159 5.109,24.854 9.97,26.744 C9.856,25.718 9.753,24.143 10.016,23.022 C10.253,22.01 11.548,16.572 11.548,16.572 C11.548,16.572 11.157,15.795 11.157,14.646 C11.157,12.842 12.211,11.495 13.522,11.495 C14.637,11.495 15.175,12.326 15.175,13.323 C15.175,14.436 14.462,16.1 14.093,17.643 C13.785,18.935 14.745,19.988 16.028,19.988 C18.351,19.988 20.136,17.556 20.136,14.046 C20.136,10.939 17.888,8.767 14.678,8.767 C10.959,8.767 8.777,11.536 8.777,14.398 C8.777,15.513 9.21,16.709 9.749,17.359 C9.856,17.488 9.872,17.6 9.84,17.731 C9.741,18.141 9.52,19.023 9.477,19.203 C9.42,19.44 9.288,19.491 9.04,19.376 C7.408,18.622 6.387,16.252 6.387,14.349 C6.387,10.256 9.383,6.497 15.022,6.497 C19.555,6.497 23.078,9.705 23.078,13.991 C23.078,18.463 20.239,22.062 16.297,22.062 C14.973,22.062 13.728,21.379 13.302,20.572 C13.302,20.572 12.647,23.05 12.488,23.657 C12.193,24.784 11.396,26.196 10.863,27.058 C12.086,27.434 13.386,27.637 14.733,27.637 C21.95,27.637 27.801,21.828 27.801,14.662 C27.801,7.495 21.95,1.686 14.733,1.686"
                        fill="#bd081c"
                      ></path>
                    </g>
                  </svg>
                </span>
                <span class="simplesocialtxt">Pinterest</span>';
                {showCounter && <span class="ssb_counter">5</span>}
              </button>
            );
          } else {
            output.push(
              <button
                rel="nofollow"
                class="simplesocial-pinterest-share"
                style={buttonStyle}
              >
                <span class="simplesocialtxt">Pinterest</span>
                {showCounter && (
                  <span class="ssb_counter ssb_pinterest_counter">5</span>
                )}
              </button>
            );
          }
          break;
        case "totalshare":
          output.push(
            <span class="ssb_total_counter">555<span>Shares</span>
            </span>
          );
          break;
        case "reddit":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_reddit-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="430.117"
                    height="430.117"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 430.117 430.117"
                    version="1.1"
                    viewBox="0 0 430.117 430.117"
                    xmlSpace="preserve"
                  >
                    <path d="M307.523 231.062c1.11 2.838 1.614 5.769 1.614 8.681 0 5.862-2.025 11.556-5.423 16.204-3.36 4.593-8.121 8.158-13.722 9.727h.01c-.047.019-.094.019-.117.037-.023 0-.061.019-.079.019a24.626 24.626 0 01-7.98 1.316c-6.254 0-12.396-2.254-17.306-6.096-4.872-3.826-8.56-9.324-9.717-15.845h-.01c0-.019 0-.042-.009-.069 0-.019 0-.038-.019-.065h.019a23.713 23.713 0 01-.551-5.021c0-5.647 1.923-11.07 5.097-15.551 3.164-4.453 7.626-7.99 12.848-9.811.019 0 .038-.01.038-.01.027 0 .027-.027.051-.027a26.476 26.476 0 019.157-1.639c5.619 0 11.154 1.704 15.821 4.821 4.611 3.066 8.354 7.561 10.23 13.143.019.037.019.07.037.103 0 .037.019.057.037.084h-.026zm-17.194 69.287c-2.202-1.428-4.751-2.291-7.448-2.291a11.66 11.66 0 00-6.445 1.955c-19.004 11.342-41.355 17.558-63.547 17.558-16.65 0-33.199-3.514-48.192-10.879l-.077-.037-.075-.028c-2.261-.924-4.837-2.889-7.647-4.76-1.428-.925-2.919-1.844-4.574-2.521-1.633-.695-3.447-1.181-5.386-1.181-1.605 0-3.292.359-4.957 1.115l-.252.098h.009a12.002 12.002 0 00-5.974 4.994c-1.372 2.23-2.046 4.826-2.046 7.411 0 2.334.551 4.667 1.691 6.786a12.163 12.163 0 004.938 4.938c21.429 14.454 46.662 21.002 71.992 20.979 22.838 0 45.814-5.287 66.27-14.911l.107-.065.103-.056c2.697-1.597 6.282-3.029 9.661-5.115 1.671-1.064 3.304-2.296 4.704-3.897a14.706 14.706 0 003.16-5.875v-.01c.266-1.026.392-2.025.392-3.024 0-1.899-.467-3.701-1.241-5.32-1.134-2.438-2.991-4.435-5.166-5.864zm-150.454-34.76c.037 0 .086.014.128.037a24.302 24.302 0 008.345 1.493c6.963 0 13.73-2.852 18.853-7.5 5.115-4.662 8.618-11.257 8.618-18.775 0-.196 0-.392-.009-.625.019-.336.028-.705.028-1.083 0-7.458-3.456-14.08-8.522-18.762-5.085-4.686-11.836-7.551-18.825-7.551-1.867 0-3.769.219-5.628.653-.028 0-.049.009-.077.009h-.028c-9.252 1.937-17.373 8.803-20.37 18.248v.01c0 .019-.009.037-.009.037a24.974 24.974 0 00-1.262 7.896c0 5.787 1.913 11.426 5.211 16.064 3.269 4.56 7.894 8.145 13.448 9.819.04.002.059.012.099.03zm290.158-67.495v.038c.066.94.084 1.878.084 2.81 0 10.447-3.351 20.493-8.941 29.016-5.218 7.976-12.414 14.649-20.703 19.177.532 4.158.84 8.349.84 12.526-.01 22.495-7.766 44.607-21.272 62.329v.009h-.028c-24.969 33.216-63.313 52.804-102.031 62.684h-.01l-.027.023a268.397 268.397 0 01-63.223 7.574c-31.729 0-63.433-5.722-93.018-17.585l-.009-.028h-.028c-30.672-12.643-59.897-32.739-77.819-62.184-9.642-15.71-14.935-34.141-14.935-52.659 0-4.19.283-8.387.843-12.536a60.094 60.094 0 01-20.255-18.687c-5.542-8.266-9.056-17.95-9.5-28.187v-.159c.009-14.337 6.237-27.918 15.915-37.932 9.677-10.011 22.896-16.554 37.075-16.554h.588a66.294 66.294 0 014.488-.159c7.122 0 14.26 1.153 21.039 3.752l.037.028.038.012c5.787 2.437 11.537 5.377 16.662 9.449 1.661-.871 3.472-1.851 5.504-2.625 31.064-18.395 67.171-25.491 102.358-27.538.306-17.431 2.448-35.68 10.949-51.65 7.08-13.269 19.369-23.599 34-27.179l.061-.03.079-.009c5.573-1.078 11.192-1.575 16.774-1.575 14.869 0 29.561 3.521 43.31 9.017 6.086-9.185 14.776-16.354 24.97-20.375l.098-.056.098-.037c5.983-1.864 12.303-2.954 18.646-2.954 6.692 0 13.437 1.223 19.756 4.046v-.023c.009.023.019.023.019.023.047.016.084.044.116.044 9.059 3.489 16.727 9.937 22.164 17.95 5.442 8.048 8.644 17.688 8.644 27.599 0 1.827-.103 3.657-.317 5.489l-.019.037c0 .028 0 .068-.01.096-1.063 12.809-7.551 24.047-16.736 32.063-9.24 8.048-21.207 12.909-33.49 12.909-1.97 0-3.958-.11-5.937-.374-12.182-.931-23.541-6.826-31.886-15.595-8.373-8.755-13.768-20.453-13.768-33.08 0-.611.056-1.237.074-1.843-11.435-5.092-23.578-9.316-35.646-9.306-1.746 0-3.491.096-5.237.273h-.019c-9.035.871-17.436 6.566-21.506 14.757v.037c-6.179 12.034-7.411 26.101-7.598 40.064 34.639 2.259 69.483 10.571 100.043 28.138h.047l.438.259c.579.343 1.652.931 2.623 1.449 2.101-1.704 4.322-3.456 6.856-4.966 9.264-6.17 20.241-9.238 31.223-9.238 4.872 0 9.749.621 14.481 1.834h.019l.196.058c.07.01.121.033.178.033v.009c11.183 2.845 21.3 9.267 28.917 17.927 7.612 8.674 12.731 19.648 13.73 31.561v.025h-.012zM328.002 84.733c0 .469.01.95.057 1.44v.084c.224 6.018 3.065 11.619 7.383 15.756 4.34 4.14 10.1 6.702 15.942 6.725h.159c.42.033.85.033 1.26.033 5.899.009 11.752-2.532 16.148-6.655 4.405-4.144 7.309-9.78 7.542-15.849l.009-.028v-.037c.038-.464.057-.903.057-1.377 0-6.247-2.922-12.202-7.496-16.612-4.555-4.406-10.688-7.136-16.735-7.12-1.951 0-3.884.266-5.778.854l-.065.005-.056.023c-4.984 1.295-9.656 4.368-13.012 8.449-3.371 4.062-5.415 9.084-5.415 14.309zm-255.69 92.845c-4.63-2.156-9.418-3.696-14.15-3.676-.794 0-1.597.047-2.39.133h-.11l-.11.014c-6.795.187-13.653 3.15-18.801 7.899-5.152 4.732-8.559 11.122-8.821 18.167v.065l-.012.058a21 21 0 00-.065 1.683c0 4.345 1.333 8.545 3.593 12.368 1.673 2.847 3.867 5.441 6.348 7.701 7.941-17.388 20.348-32.145 34.518-44.412zm301.754 85.057c0-15.5-5.592-31.069-14.646-43.604-18.053-25.119-46.055-41.502-75.187-50.636l-.205-.072a239.667 239.667 0 00-16.933-4.534c-17.025-3.876-34.48-5.806-51.917-5.806-23.414 0-46.827 3.465-69.245 10.379-29.125 9.243-57.221 25.51-75.233 50.71v.019c-9.129 12.587-14.475 28.208-14.475 43.763 0 5.727.716 11.453 2.23 17.025l.019.01c3.278 12.508 9.689 23.671 17.989 33.393 8.295 9.745 18.472 18.058 29.176 24.839 2.371 1.47 4.751 2.87 7.187 4.237 31.094 17.356 66.898 24.964 102.445 24.964 6.012 0 12.06-.214 18.033-.644 35.797-2.959 71.742-13.525 100.8-35.115l.01-.023c9.25-6.837 17.818-15.112 24.595-24.525 6.805-9.418 11.789-19.947 14.002-31.382v-.033l.009-.01a62.283 62.283 0 001.346-12.955zm28.254-61.685c-.009-3.762-.868-7.507-2.753-11l-.047-.044-.019-.056c-2.521-5.19-6.479-9.11-11.248-11.782-4.77-2.69-10.352-4.056-15.952-4.056-5.063 0-10.1 1.132-14.57 3.379 14.216 12.344 26.687 27.179 34.746 44.636a29.093 29.093 0 006.464-8.084c2.157-4.023 3.379-8.538 3.379-12.993z"></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">reddit </span>
                {showCounter && <span class="ssb_counter">5</span>}
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-reddit-share" style={buttonStyle}>
                <span class="simplesocialtxt">Reddit</span>
                {showCounter && (
                  <span class="ssb_counter ssb_reddit_counter"> 5 </span>
                )}
              </button>
            );
          }
          break;
        case "whatsapp":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_whatsapp-icon simplesocial-whatsapp-share">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 90 90"
                    version="1.1"
                    viewBox="0 0 90 90"
                    xmlSpace="preserve"
                  >
                    <path d="M90 43.841c0 24.213-19.779 43.841-44.182 43.841a44.256 44.256 0 01-21.357-5.455L0 90l7.975-23.522a43.38 43.38 0 01-6.34-22.637C1.635 19.628 21.416 0 45.818 0 70.223 0 90 19.628 90 43.841zM45.818 6.982c-20.484 0-37.146 16.535-37.146 36.859 0 8.065 2.629 15.534 7.076 21.61L11.107 79.14l14.275-4.537A37.122 37.122 0 0045.819 80.7c20.481 0 37.146-16.533 37.146-36.857S66.301 6.982 45.818 6.982zm22.311 46.956c-.273-.447-.994-.717-2.076-1.254-1.084-.537-6.41-3.138-7.4-3.495-.993-.358-1.717-.538-2.438.537-.721 1.076-2.797 3.495-3.43 4.212-.632.719-1.263.809-2.347.271-1.082-.537-4.571-1.673-8.708-5.333-3.219-2.848-5.393-6.364-6.025-7.441-.631-1.075-.066-1.656.475-2.191.488-.482 1.084-1.255 1.625-1.882.543-.628.723-1.075 1.082-1.793.363-.717.182-1.344-.09-1.883-.27-.537-2.438-5.825-3.34-7.977-.902-2.15-1.803-1.792-2.436-1.792-.631 0-1.354-.09-2.076-.09s-1.896.269-2.889 1.344c-.992 1.076-3.789 3.676-3.789 8.963 0 5.288 3.879 10.397 4.422 11.113.541.716 7.49 11.92 18.5 16.223C58.2 65.771 58.2 64.336 60.186 64.156c1.984-.179 6.406-2.599 7.312-5.107.9-2.512.9-4.663.631-5.111z"></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">Whatsapp</span>
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-whatsapp-share" style={buttonStyle}>
                <span class="simplesocialtxt">WhatsApp</span>
              </button>
            );
          }
          break;
        case "viber":
          if ("simple-icons" === theme) {
            output.push(
              <button class="simplesocial-viber-share ssb_viber-icon">
                <span class="icon">
                  <svg
                    aria-labelledby="simpleicons-viber-icon"
                    role="img"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title id="simpleicons-viber-icon">Viber icon</title>
                    <path d="M20.812 2.343c-.596-.549-3.006-2.3-8.376-2.325 0 0-6.331-.38-9.415 2.451C1.302 4.189.698 6.698.634 9.82.569 12.934.487 18.774 6.12 20.36h.005l-.005 2.416s-.034.979.609 1.178c.779.24 1.236-.504 1.98-1.303.409-.439.972-1.088 1.397-1.582 3.851.322 6.813-.416 7.149-.525.777-.254 5.176-.816 5.893-6.658.738-6.021-.357-9.83-2.338-11.547v.004zm.652 11.112c-.615 4.876-4.184 5.187-4.83 5.396-.285.092-2.895.738-6.164.525 0 0-2.445 2.941-3.195 3.705-.121.121-.271.166-.361.145-.135-.029-.164-.18-.164-.404l.015-4.006c-.015 0 0 0 0 0-4.771-1.336-4.485-6.301-4.425-8.91.044-2.596.538-4.726 1.994-6.167 2.611-2.371 7.997-2.012 7.997-2.012 4.543.016 6.721 1.385 7.223 1.846 1.674 1.432 2.529 4.865 1.904 9.893l.006-.011zM7.741 4.983c.242 0 .459.109.629.311.004.002.58.695.83 1.034.235.32.551.83.711 1.115.285.51.104 1.032-.172 1.248l-.566.45c-.285.229-.25.653-.25.653s.84 3.157 3.959 3.953c0 0 .426.039.654-.246l.451-.569c.213-.285.734-.465 1.244-.181.285.15.795.466 1.116.704.339.24 1.032.826 1.036.826.33.271.404.689.18 1.109v.016c-.23.405-.541.78-.934 1.141h-.008c-.314.27-.629.42-.944.449-.03 0-.075.016-.136 0-.135 0-.27-.029-.404-.061v-.014c-.48-.135-1.275-.48-2.596-1.216-.855-.479-1.574-.96-2.189-1.455-.315-.255-.645-.54-.976-.87l-.076-.028-.03-.03-.029-.029c-.331-.33-.615-.66-.871-.98-.48-.609-.96-1.327-1.439-2.189-.735-1.32-1.08-2.115-1.215-2.596H5.7c-.045-.134-.075-.269-.06-.404-.015-.061 0-.105 0-.141.03-.299.189-.614.458-.944h.005c.355-.39.738-.704 1.146-.933.164-.091.329-.135.479-.135h.016l-.003.012zm4.095-.683h.116l.076.002h.02l.089.005h.511l.135.015h.074l.15.016h.03l.104.015h.016l.074.015c.046 0 .076.016.105.016h.091l.075.029.06.016.06.015.03.015h.045l.046.016h.029l.074.016.045.014.046.016.06.016.03.014c.03 0 .06.016.091.016l.044.015.046.016.119.044.061.031.135.06.045.015.045.016.09.045.061.015.029.015.076.031.029.014.061.031.045.014.045.03.059.03.046.029.03.016.061.03.044.03.075.045.045.016.074.044.016.015.045.031.09.074.046.03.044.03.031.014.045.031.074.074.061.045.045.03.016.015.029.016.074.061.046.044.03.03.045.029.045.031.029.015.12.12.06.061.135.135.031.029c.016.016.045.045.061.075l.029.03.166.194.045.06c.014.016.014.031.029.031l.09.135.045.045.09.12.076.12.045.09.059.105.045.09.016.029.029.061.076.15.074.149.031.075c.059.135.104.27.164.42.074.195.135.404.18.63.045.165.076.315.105.48l.029.27.045.3c.016.121.031.256.031.375.014.121.014.24.014.359v.256c0 .016-.006.029-.014.045-.016.03-.031.045-.061.075-.021.015-.049.046-.08.046-.029.014-.059.014-.09.014h-.045c-.029 0-.059-.014-.09-.029-.029-.016-.061-.03-.074-.061-.016-.029-.045-.061-.061-.09s-.031-.06-.031-.09v-.359c-.014-.209-.029-.425-.059-.639-.016-.146-.045-.284-.061-.42 0-.074-.016-.146-.029-.209l-.029-.15-.038-.141-.016-.09-.045-.15c-.029-.12-.074-.24-.119-.36-.029-.091-.061-.165-.105-.239l-.029-.076-.135-.27-.031-.045c-.061-.135-.135-.27-.225-.391l-.045-.074h-.201l-.064-.091c-.055-.089-.114-.165-.18-.239l-.125-.15-.015-.016-.046-.057-.035-.045-.075-.074-.015-.03-.07-.06-.045-.046-.083-.075-.04-.037-.046-.045-.015-.016c-.016-.015-.045-.045-.075-.06l-.076-.062-.03-.015-.061-.046-.074-.06-.045-.036-.03-.016-.06-.053c0-.016-.016-.016-.031-.016l-.029-.029-.015-.016v-.013l-.03-.014-.061-.037-.044-.031-.075-.045-.06-.045-.029-.016-.032-.013h-.09l-.019-.016-.065-.035-.009-.014-.03-.016-.045-.021h-.012l-.045-.016-.025-.015-.045-.015-.01-.011-.03-.016-.053-.029-.03-.015-.09-.03-.074-.029-.137-.016-.044-.029c-.015-.01-.03-.016-.046-.016l-.029-.015c-.029-.011-.045-.016-.075-.03l-.03-.016h-.029l-.061-.029-.029-.016-.045-.015h-.092c-.008 0-.019-.005-.03-.007h-.09l-.045-.016h-.015l-.045-.016h-.041c-.025-.014-.045-.014-.07-.014l-.01-.016-.06-.015c-.03-.016-.056-.016-.084-.016l-.045-.015-.05-.016-.045-.014-.061-.016h-.061l-.179-.022h-.09l-.116-.015h-.076l-.068-.008h-.03l-.054-.016h-.285l-.01-.015h-.061c-.03 0-.064-.015-.09-.03-.03-.016-.061-.029-.081-.06l-.03-.046c-.029-.029-.029-.06-.045-.09-.014-.028-.014-.059-.014-.089s0-.06.015-.09c.016-.029.029-.06.061-.075.015-.03.044-.044.074-.06.029-.016.061-.03.09-.03h.061l.015.066zm.554 1.574l.037.003.061.006c.008 0 .018 0 .029.003.022 0 .045.004.075.006l.06.008.024.016.045.015.048.015.045.016h.03l.042.015.07.015.056.016.026.014h.073l.119.028.046.015.045.015.045.016s.015 0 .015.015l.046.015.044.016.045.016c.015 0 .03.014.046.014.007 0 .014.016.025.016l.064.03h.029l.09.03.05.029.046.03.108.045.06.015.031.031c.045.014.09.044.135.059l.048.03.048.03.049.029c.045.03.082.046.121.076l.029.014.041.031.022.015.075.045.037.03.065.043.029.015.03.015.046.03.06.046c.015.014.022.014.034.029.01.015.016.015.025.03l.033.03.036.029.03.03.046.046.029.03.016.016.09.089.016.016c0 .015.015.03.029.03l.016.013.045.046.029.045.03.03.045.06.046.046.09.119.014.029.061.076.016.029.015.031.015.029.016.03c.016.015.016.03.029.06l.043.076.016.015.029.061.031.044c.014.015.014.029.029.045l.03.045.03.061.029.059.016.046c.015.044.045.075.06.12 0 .015.015.029.015.045l.045.119.061.195c0 .016.015.045.015.061l.046.135.044.18.046.24c.014.074.014.135.029.211.016.119.03.238.03.359l.015.21v.165c0 .016 0 .029-.015.045l-.044.043c-.029.023-.045.045-.074.061-.03.015-.061.029-.09.04-.031.016-.075.016-.105.016-.029 0-.061-.016-.09-.03-.016 0-.03-.016-.045-.021-.031-.014-.061-.039-.075-.065-.03-.03-.046-.06-.046-.091l-.014-.044v-.313c0-.133-.016-.256-.031-.385-.015-.135-.044-.285-.074-.42-.029-.09-.045-.18-.075-.26l-.03-.091-.029-.075-.016-.03-.045-.12-.045-.09-.075-.149-.069-.12v-.019l-.029-.047-.03-.038-.045-.075-.046-.061-.089-.119c-.046-.061-.09-.12-.142-.178-.014-.015-.029-.029-.029-.045l-.03-.029-.017-.016-.03-.014-.03-.027v-.146l-.119-.113-.075-.068v-.014l-.03-.031-.038-.029-.015-.016c0-.015-.016-.015-.029-.015l-.046-.016-.015-.015-.061-.045-.014-.016-.016-.015c-.012-.015-.023-.015-.03-.015l-.06-.045-.016-.016-.06-.029-.011-.016-.045-.029-.03-.016-.03-.029-.029-.031h-.016c-.029-.029-.06-.044-.105-.06l-.044-.03-.03-.014-.016-.016-.045-.03-.044-.015-.06-.03-.046-.015-.015-.016-.056-.014v-.012l-.091-.03-.06-.03-.03-.015h-.06c-.03-.015-.045-.015-.075-.03H13.2l-.045-.016h-.044l-.046-.014-.029-.016h-.061l-.061-.015-.029-.016h-.165l-.069-.015H12.3l-.046-.016c-.029-.014-.06-.029-.09-.06-.014-.03-.045-.06-.06-.089-.015-.031-.03-.061-.03-.091v-.09c.006-.046.016-.075.03-.105.008-.015.015-.03.03-.045.018-.03.045-.06.075-.075.015-.015.03-.015.044-.029.031-.016.061-.016.091-.016h.06l-.014.055zm.454 1.629c.015 0 .03 0 .044.004.016 0 .031 0 .046.002l.052.005c.104.009.213.024.318.046l.104.023.026.008.114.029.059.02.046.016c.045.014.091.045.135.06l.016.015.06.03.09.046.029.014c.016.016.031.016.046.03.015.016.045.03.06.045.061.03.105.075.15.105l.105.09.09.091.061.074.029.029.03.031.044.06.091.135.075.135.06.12.046.105c.044.104.06.195.09.299.029.091.045.196.06.285l.015.15.016.136V9.8c0 .045-.016.075-.03.105-.015.029-.046.074-.075.09-.03.029-.061.045-.105.061-.029.014-.06.014-.09.014-.029 0-.06 0-.09-.014l-.104-.046c-.03-.03-.06-.045-.091-.091-.015-.029-.029-.06-.045-.104v-.166l-.015-.105-.015-.119-.016-.105-.016-.06c0-.015-.014-.045-.014-.06-.03-.121-.09-.24-.15-.36l-.061-.06-.047-.06-.045-.045-.015-.03-.075-.06-.061-.061-.059-.045c-.016-.015-.03-.015-.061-.029l-.09-.061-.061-.03-.029-.015h-.016l-.076-.031-.09-.03-.09-.015h-.075l-.044-.015-.035-.007h-.045l-.06-.016h-.255l-.015-.075h-.039c-.03-.004-.055-.015-.08-.029-.035-.021-.064-.045-.09-.08-.018-.029-.034-.061-.045-.09-.008-.029-.012-.06-.012-.09 0-.037 0-.075.015-.113.015-.039.03-.07.06-.1l.061-.045c.029-.016.061-.03.09-.03l.062-.075h.032z" />
                  </svg>
                </span>
                <span class="simplesocialtxt">Viber</span>
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-viber-share">
                <span class="simplesocialtxt">Viber</span>
              </button>
            );
          }
          break;
        case "fblike":
          const likeButtonClasses = classnames(
            "fb-like",
            "ssb-fb-like",
            "fb_iframe_widget",
            { [`${likeButtonSize}`]: likeButtonSize }
          );
          output.push(
            <div
              class={likeButtonClasses}
              data-layout="button_count"
              data-action="like"
              data-size="small"
              data-show-faces="false"
              data-share="false"
            >
              <img src={SSB.plugin_url + "/assets/images/fblike.svg"} />{" "}
            </div>
          );
          break;
        case "messenger":
          if ("simple-icons" === theme) {
            output.push(
              <button class="simplesocial-viber-share ssb_msng-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    x="0"
                    y="0"
                    version="1.1"
                    viewBox="-889.5 1161 18 19"
                    xmlSpace="preserve"
                  >
                    <path
                      fill="#FFF"
                      d="M-880.5 1161c-5 0-9 3.8-9 8.5 0 2.4 1 4.5 2.7 6v4.5l3.8-2.3c.8.2 1.6.3 2.5.3 5 0 9-3.8 9-8.5s-4-8.5-9-8.5zm.9 11.2l-2.4-2.4-4.3 2.4 4.7-5.2 2.4 2.4 4.2-2.4-4.6 5.2z"
                      opacity="0.99"
                    ></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">Messenger</span>
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-msng-share">
                <span class="simplesocialtxt">Messenger</span>
              </button>
            );
          }
          break;
        case "email":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_email-icon simplesocial-email-share">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="11.9"
                    x="0"
                    y="0"
                    version="1.1"
                    viewBox="-1214.1 1563.9 16 11.9"
                    xmlSpace="preserve"
                  >
                    <path d="M-1214.1 1565.2v1l8 4 8-4v-1c0-.7-.6-1.3-1.3-1.3h-13.4c-.7 0-1.3.5-1.3 1.3zm0 2.2v7.1c0 .7.6 1.3 1.3 1.3h13.4c.7 0 1.3-.6 1.3-1.3v-7.1l-8 4-8-4z"></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">Email</span>
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-email-share">
                <span class="simplesocialtxt">Email</span>
              </button>
            );
          }
          break;
        case "print":
          if ("simple-icons" === theme) {
            output.push(
              <button class=" ssb_print-icon simplesocial-email-share">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="13.7"
                    x="0"
                    y="0"
                    version="1.1"
                    viewBox="-1296.9 1876.4 16 13.7"
                    xmlSpace="preserve"
                  >
                    <g fill="#FFF">
                      <path d="M-1288.9 1879.7h6.9c.4 0 .7.1.9.5.1.2.1.4.1.6v5.1c0 .7-.4 1.1-1.1 1h-1.8c-.1 0-.2 0-.2.2v2c0 .6-.4 1-1 1H-1292.9c-.3 0-.5 0-.8-.1-.3-.2-.5-.5-.5-.9v-2c0-.2-.1-.2-.2-.2h-1.7c-.7 0-1-.4-1-1v-5.1c0-.4.2-.8.6-.9.2-.1.3-.1.5-.1 2.5-.1 4.8-.1 7.1-.1zm0 5.2h-4.2c-.1 0-.2 0-.2.2v4c0 .3.1.4.4.4h8c.2 0 .3-.2.3-.3v-4c0-.2 0-.2-.2-.2-1.3-.1-2.7-.1-4.1-.1zm4.7-2.5c.4 0 .7-.3.7-.7 0-.4-.3-.7-.8-.7-.4 0-.7.3-.7.7.1.4.4.7.8.7zM-1283.9 1879h-9.8c-.1 0-.2 0-.2-.2v-1.5c0-.5.4-1 .9-1h8.1c.6 0 1 .4 1 1v1.7z"></path>
                      <path d="M-1291.9 1886.9v-.6h6v.6h-6zM-1289.6 1888.2h-2.1c-.1 0-.2 0-.2-.2v-.3c0-.1 0-.2.2-.2h4.2c.3 0 .3 0 .3.3 0 .4 0 .4-.4.4h-2z"></path>
                    </g>
                  </svg>
                </span>
                <span class="simplesocialtxt">Print</span>
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-print-share">
                <span class="simplesocialtxt">Print</span>
              </button>
            );
          }
          break;
        case "tumblr":
          if ("simple-icons" === theme) {
            output.push(
              <button class="ssb_tumblr-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.6"
                    height="17.8"
                    x="0"
                    y="0"
                    enableBackground="new -299.1 388.3 12.6 17.8"
                    version="1.1"
                    viewBox="-299.1 388.3 12.6 17.8"
                    xmlSpace="preserve"
                  >
                    <path
                      fill="#FFF"
                      d="M-294.7 388.3h3.2v4.4h5v3.4h-5v5c0 1.2.6 1.8 1.8 2 1.1.1 2.1 0 3-.5.1 0 .1-.1.2-.1v2.5c0 .1 0 .2-.2.3-1.6.6-3.2.9-5 .8-1-.1-2-.3-2.9-.8-1.2-.7-1.8-1.7-1.8-3.1V396v-.3h-2.7v-.2-2.2c0-.1 0-.2.2-.2.3-.1.7-.2 1-.3 1.6-.6 2.6-1.8 3-3.5 0-.1.1-.3.1-.4 0-.3.1-.5.1-.6z"
                    ></path>
                  </svg>
                </span>
                <span class="simplesocialtxt">tumblr</span>
                {showCounter && <span class="ssb_counter">5</span>}
              </button>
            );
          } else {
            output.push(
              <button class="simplesocial-tumblr-share" style={buttonStyle}>
                <span class="simplesocialtxt">Tumblr</span>
                {showCounter && (
                  <span class="ssb_counter ssb_tumblr_counter"> 5</span>
                )}
              </button>
            );
          }
      }
    });

    return <Fragment>{output}</Fragment>;
  }
}

export default Buttons;



// WEBPACK FOOTER //
// blocks/shortcode/buttons.js